<app-layout>
  <div *ngIf="siparis">
    <div class="row">
      <div class="col-12" *ngIf="id!=='0'">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Siparis Onay Hareketleri</h4>
          </div>
          <div class="card-body p-0">
            <div class="row">
              <div class="col-12">
                <div class="table-responsive">
                  <table class="table card-table table-vcenter text-nowrap datatable">
                    <thead>
                      <tr>
                        <th>Durum</th>
                        <th>Onay Durumu</th>
                        <th>Kullanıcı</th>
                        <th>Tarih</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody *ngIf="siparisHareketler">
                      <tr *ngFor="let k of siparisHareketler">
                        <td>{{k.siparisOnaySeviye?.kullaniciGrup?.isim}} Onayında</td>
                        <td>{{k.isOnayText}}</td>
                        <td>{{k.kullanici?.adSoyad}}</td>
                        <td>{{k.olusturmaTarih | date: 'dd.MM.yyyy HH:mm'}}</td>
                        <td class="text-right">
                          <div class="btn btn-sm btn-pill btn-success"
                            *ngIf="k.siparisOnaySeviye.id === siparis.siparisOnaySeviyeId && k.siparisOnaySeviye?.kullaniciGrupId===userGrupId && k.isOnay==null"
                            (click)="siparisOnayla(k.siparisOnaySeviye?.id,true)">Onayla
                          </div>
                          <div class="btn btn-sm btn-pill btn-danger ml-2"
                            *ngIf="k.siparisOnaySeviye.id === siparis.siparisOnaySeviyeId && k.siparisOnaySeviye?.kullaniciGrupId===userGrupId && k.isOnay==null"
                            (click)="siparisOnayla(k.siparisOnaySeviye.id,false)">Reddet
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">
              Talep Bilgileri
            </h3>
          </div>
          <div class="card-body">
            <dl class="row">
              <app-talep-detay [source]="siparis?.talep" [source2]="siparis" [source3]="siparis.teklif?.teslimYeri.aciklama" (emittedAciklama)="setAciklama($event)"></app-talep-detay>
            </dl>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="card p-0">
          <div class="card-header">
            <h3 class="card-title">Girilen İrsaliyeler</h3>
            <div class="card-options">
              <div class="btn btn-sm btn-pill btn-primary" (click)="addIrsaliye()"
                *ngIf="!siparis.isKapatildi && ((!irsaliyeEkle && siparis.durum === DURUM_ONAYLANDI) || (siparis.durum === DURUM_IRS_OLUSTU && siparis.toplamSiparisMiktar - siparis.toplamIrsaliyeMiktar > 0))">
                Yeni İrsaliye
              </div>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table card-table table-vcenter text-nowrap datatable">
              <thead>
                <tr>
                  <th class="w-1">#</th>
                  <th>İrsaliye Tarihi</th>
                  <th>İrsaliye No</th>
                  <th>Firma</th>
                  <th>Toplam Adet</th>
                  <th>Toplam Tutar</th>
                  <th>Durum</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let ir of siparis.irsaliyeler;let i=index;">
                  <td><span class="text-muted">{{ir.id}}</span></td>
                  <td>{{ir.irsaliyeTarihiText}}</td>
                  <td>{{ir.irsaliyeNo}}</td>
                  <td>{{ir.siparis?.cari?.firmaUnvani}}</td>
                  <td>{{ir.toplamAdet}}</td>
                  <td>{{ir.toplamTutar}}</td>
                  <td>{{ir.durumText}}</td>
                  <td>
                    <div class="btn btn-sm btn-primary" (click)="irsaliyeDetay(ir)">İncele</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="col-12" *ngIf="irsaliyeEkle">
        <div class="card p-0">
          <div class="card-header">
            <h3 class="card-title">Yeni İrsaliye</h3>
          </div>
          <div class="row p-3">
            <div class="col-3">
              <div class="mb-3">
                <label class="form-label">İrsaliye No</label>
                <input class="form-control" [(ngModel)]="irsaliyeNo" />
              </div>
            </div>
            <div class="col-3">
              <div class="mb-3">
                <label class="form-label">İrsaliye Tarihi</label>
                <div class="input-icon">
                  <input mwlFlatpickr class="form-control mb-2 flatpickr-input" type="text"
                    placeholder="İrsaliye Tarihi" [(ngModel)]="irsaliyeTarihi" [altInput]="true"
                    [convertModelValue]="true">
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <div class="form-label">İrsaliye Notu</div>
                <textarea class="form-control" name="example-textarea-input" rows="1" placeholder="İrsaliye Notu"
                  [(ngModel)]="irsaliyeNotu"></textarea>
              </div>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table card-table table-vcenter text-nowrap datatable">
              <thead>
                <tr>
                  <th class="w-1">Stok Kodu</th>
                  <th>Stok Adı</th>
                  <th>Ölçü Birimi</th>
                  <th>Sipariş Miktarı</th>
                  <th>İrsaliyesi Girilmiş Miktar</th>
                  <th>Firma Teklifi (Birim Fiyatı)</th>
                  <th>Para Birimi</th>
                  <th>İrsaliye Miktar</th>
                  <th>İrsaliye Fiyat</th>
                  <th>İrsaliye Para Birimi</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let k of siparis.siparisKalemler;let i=index;">
                  <td><span class="text-muted">{{k.teklifKalem.talepKalem?.stokKodu}}</span></td>
                  <td>{{k.teklifKalem.talepKalem?.stokAdi}}</td>
                  <td>{{k.teklifKalem.talepKalem?.olcuBirimi}}</td>
                  <td>{{k.miktar}}</td>
                  <td>{{k.girilmisIrsaliyeAdeti}}</td>
                  <td>{{k.teklifKalem.tutar}}</td>
                  <td>{{k.teklifKalem.paraBirimi?.aciklama}}</td>
                  <td><input type="number" class="form-control" *ngIf="irsaliyeEkle"
                      [(ngModel)]="yeniIrsaliyeKalem[i].adet" (change)="calculateIrsaliyeTotalTutarText()"></td>
                  <td><input type="number" class="form-control" *ngIf="irsaliyeEkle" readonly
                      [(ngModel)]="yeniIrsaliyeKalem[i].tutar" (change)="calculateIrsaliyeTotalTutarText()"></td>
                  <td>
                    <app-loading-input *ngIf="paraBirimleri==null"></app-loading-input>
                    <select *ngIf="paraBirimleri && irsaliyeEkle" class="form-control" [(ngModel)]="k.teklifKalem.paraBirimiId"
                      (change)="calculateIrsaliyeTotalTutarText()" [ngModelOptions]="{standalone: true}">
                      <option [value]="null" disabled selected>Şeçiniz</option>
                      <option *ngFor="let p of paraBirimleri" [ngValue]="p.id">{{p.aciklama}}</option>
                    </select>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="card-footer">
            <div class="btn btn-sm btn-success" (click)="irsaliyeKaydet()">Oluştur</div>
            <div class="float-right">
              <b class="text-right">İrsaliye Toplamı:</b> {{totalIrsaliyeText}}
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="card p-0">
          <div class="card-header">
            <h3 class="card-title">Sipariş Kalemleri</h3>
            <div class="card-options">
              <div class="btn btn-sm btn-pill btn-warning"
                *ngIf="!siparis.isKapatildi" (click)="siparisKapat()">
                Siparişi Kapat
              </div>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table card-table table-vcenter text-nowrap datatable">
              <thead>
                <tr>
                  <th class="w-1">Stok Kodu</th>
                  <th>Stok Adı</th>
                  <th>Ölçü Birimi</th>
                  <th>Sipariş Miktarı</th>
                  <th>Firma Teklifi (Birim Fiyatı)</th>
                  <th>Para Birimi</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let k of siparis.siparisKalemler;let i=index;">
                  <td><span class="text-muted">{{k.teklifKalem.talepKalem?.stokKodu}}</span></td>
                  <td>{{k.teklifKalem.talepKalem?.stokAdi}}</td>
                  <td>{{k.teklifKalem.talepKalem?.olcuBirimi}}</td>
                  <td>{{k.miktar}}</td>
                  <td>{{k.teklifKalem.tutar}}</td>
                  <td>{{k.teklifKalem.paraBirimi?.aciklama}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="card-footer text-right">
            <b>Siparis Toplamı:</b> {{totalTutarText}}
          </div>
        </div>
      </div>
    </div>
  </div>
</app-layout>